import axios from 'axios';

const getList = params => axios.get('/produtos/page', {
  params,
});
const get = id => axios.get(`/produtos/${id}`, {});

const save = (produto) => {
  if (produto.id) {
    return axios.put(`/produtos/${produto.id}`, produto);
  }
  return axios.post('/produtos', produto);
};

const remover = id => axios.delete(`/produtos/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
